export default (() => {
  window.addEventListener('DOMContentLoaded', (event) => {
    const tables = Array.from(document.querySelectorAll(('[data-table-scroller]')));
    tables.forEach((table) => {
      const options = JSON.parse(table.dataset.tableScroller);
      if (options.maxCols) {
        const cols = Array.from(table.querySelectorAll('thead td'));
        if (cols && cols.length > options.maxCols) {
          const viewport = table.querySelector('[data-table-viewport');
          const container = viewport.closest('.col-12');
          if (container) {
            container.classList.add('col-xl-10', 'mx-xl-auto');
          }
        }
      }
    })
  });

  window.addEventListener('click', (event) => {
    const button = event.target.closest('[data-table-scroll]');
    const container = event.target.closest('[data-table-scroller]');
    const viewport = container && container.querySelector('[data-table-viewport]');
    if (button && viewport) {
      const dir = button.dataset.tableScroll;
      if (dir === 'start') {
        viewport.scrollLeft = 0;
      }
      else if (dir === 'end') {
        viewport.scrollLeft = viewport.scrollWidth - viewport.clientWidth;
      }
    }
  });
})();
